module.exports = __webpack_public_path__ + "static/media/trans_banner.f7a16bfd.png";